import React from "react";
import { PageHead } from "../components/PageHead";
import { DataTable } from "../components/DataTable";
import { Badge } from "../components/Badges";
import { fmtDate } from "../lib/format";

const ACTION_CLS = { scrap: "b-red", reissue: "b-violet", create: "b-green", convert: "b-green", dispatch: "b-blue", edit: "b-blue", status: "b-blue", update: "b-blue", reset_password: "b-amber", password_change: "b-slate" };

function fmtVal(v) {
  if (v == null) return "—";
  if (typeof v === "object") return Object.entries(v).map(([k, val]) => `${k}: ${val}`).join(", ");
  return String(v);
}

export default function Audit() {
  const columns = [
    { key: "changed_at", label: "When", sortable: true, mono: true, render: (v) => <span className="t-mut" style={{ whiteSpace: "nowrap" }}>{fmtDate(v)}</span> },
    { key: "changed_by_name", label: "User", sortable: true, render: (v) => <span className="t-strong">{v || "—"}</span> },
    { key: "action", label: "Action", sortable: true, render: (v) => <Badge label={v} cls={ACTION_CLS[v] || "b-slate"} /> },
    { key: "entity_type", label: "Entity", sortable: true, mono: true },
    { key: "new_value", label: "Change", render: (v) => <span className="t-mut" style={{ fontSize: 12.5 }}>{fmtVal(v)}</span> },
    { key: "note", label: "Note", render: (v) => <span className="t-mut" style={{ fontSize: 12 }}>{v || "—"}</span> },
  ];
  return (
    <>
      <PageHead crumb="Records" title="Audit Log"
        sub="Who changed what, when — old value, new value, user & timestamp. Sortable & searchable." />
      <DataTable endpoint="/audit-log" columns={columns} rowKey="id" testid="audit"
        defaultSort={{ by: "changed_at", dir: "desc" }} searchPlaceholder="Search user, action, entity…" initialLimit={50} />
    </>
  );
}
